"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListAvatar = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const components_1 = require("@bluebase/components");
const ListItemAvatar_1 = tslib_1.__importDefault(require("@material-ui/core/ListItemAvatar"));
exports.ListAvatar = (props) => {
    return (React.createElement(ListItemAvatar_1.default, null,
        React.createElement(components_1.Avatar, Object.assign({}, props))));
};
